import { render, staticRenderFns } from "./ViewRecords.vue?vue&type=template&id=5bce9c16&scoped=true&"
import script from "./ViewRecords.vue?vue&type=script&lang=js&"
export * from "./ViewRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce9c16",
  null
  
)

component.options.__file = "ViewRecords.vue"
export default component.exports